import DataTable from "datatables.net-dt";
import languageUK from 'datatables.net-plugins/i18n/uk.mjs';

export default () => ({
    dataset: [],
    columns: [],
    dataTable: null,
    isLoading: true,

    async init() {

        const response = await this.fetchPost(`${rozetka_learnpress_global.restApi.url}load-user-quizzes`)

        this.isLoading = false

        jQuery(() => {
            this.reportTable = new DataTable("#quizzesListTable", {
                data: response.data.dataset,
                pageLength: 10,
                deferRender: true,
                fixedHeader: true,
                responsive: true,
                scrollX: true,
                autoWidth: true,
                language: languageUK,
                fixedColumns: {
                    start: 2
                },
                order: [[3, 'desc']],
                layout: {
                    topEnd: {
                        search: {
                            boundary: true
                        }
                    }
                },
                columns: response.data.columns.map((col, index) => {
                    if (index === 0) {
                        return {
                            ...col,
                            render: function (data, type, row) {
                                const url = row['url']
                                return `<a href="${url}" target="_blank" title="${data}">${data}</a>`
                            }
                        };
                    }

                    if (index === 1) {
                        return {
                            ...col,
                            render: function (data, type, row) {
                                return `${data}% виконання`
                            }
                        }
                    }

                    return col
                })
            })
        })
    },

    async fetchPost(url, body = {}) {
        const response = await fetch(url,
        {
            method: 'POST',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-WP-Nonce": rozetka_learnpress_global.restApi.nonce
            },
            body: JSON.stringify(body)
        })

        return await response.json()
    }
})